import { inject } from '@angular/core'
import type { HttpInterceptorFn } from '@angular/common/http'
import { LinguiService } from '@tocdk/lingui-angular'
import { environment } from '../../../environments/environment'

const CONTENT_LOCALE_HEADER = 'X-Content-Locale'

/**
 * Tells the API which content locale the viewer sees, so server-side i18n_text
 * sorting matches the displayed names (#269). The locale is an ambient viewer
 * property (the lingui UI locale), not list-query state, so it travels as a
 * header — keeping it out of list URLs / url-state round-trips. Sent on every
 * API request (GET included — list sort is a GET); endpoints that don't sort
 * i18n columns simply ignore it.
 */
export const contentLocaleInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiBase)) return next(req)
  const locale = inject(LinguiService).locale()
  if (!locale) return next(req)
  return next(req.clone({ headers: req.headers.set(CONTENT_LOCALE_HEADER, locale) }))
}
